import React from 'react';

import { Navigate, Outlet } from 'react-router-dom';
import { UserService } from 'services/user-service';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { UserAccess } from 'shared/interfaces/User';

interface RoleRouteGuardProps {
  minAccessRole: UserAccess;
}

export const RoleRouteGuard = ({ minAccessRole }: RoleRouteGuardProps) => {
  return UserService.hasUserAccessWithMinRole(minAccessRole) ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTE_LINKS.smartAssistants} />
  );
};
